<template>
  <div class="off-canvas">
    <!-- off-screen toggle button -->
    <a class="off-canvas-toggle btn btn-primary btn-action" v-on:click.prevent="opened = true">
      <i class="icon icon-menu"></i>
    </a>

    <div id="menu" class="off-canvas-sidebar" :class="{ 'active': opened}">
      <ul>
        <li>
          <router-link :to="{ name: 'medics' }">
            <i class="fas fa-notes-medical"></i>
            Médicos
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'mi-registro' }">Hospitalizaciones</router-link>
        </li>
        <!-- <li v-if="isMedic">
          <router-link :to="{ name: 'citas' }">
            <i class="fas fa-notes-medical"></i>
            Citas pendientes
          </router-link>
        </li>
        <li v-if="!isMedic">
          <router-link :to="{name: 'nueva-cita'}">
            <i class="fas fa-notes-medical"></i>
            Solicitar visita
          </router-link>
        </li> -->
        <!-- <li v-if="isMedic">
          <router-link :to="{ name: 'visits' }">
            <i class="fas fa-notes-medical"></i>
            Revisiones
          </router-link>
        </li> -->
        <li>
          <router-link :to="{ name: 'patients' }" v-if="kind == 'Medic'">
            <i class="fas fa-notes-medical"></i>
            Pacientes
          </router-link>
        </li>
        <li>
          <router-link :to="{name: 'profile' }">Perfil</router-link>
        </li>
      </ul>

      <a
        v-on:click.prevent="registerAsMedic"
        class="register-medic" v-if="!isMedic"
      >Solicita aquí tu alta como médico</a>
    </div>

    <a class="off-canvas-overlay" v-on:click.prevent="opened = false"></a>

    <div class="off-canvas-content">
      <!-- off-screen content -->
    </div>
  </div>
</template>
<script>
import MedicsManager from "../managers/medicsManager";
// import web3 from 'web3'
import gun from "../managers/gun";

export default {
  props: {
    kind: String,
        isMedic: Boolean
  },
  data() {
    return {
      opened: false,
      medicContract: null
    };
  },
  methods: {
    async registerAsMedic() {
      console.log(gun.user().is);
      var msg = this.medicContract.methods.RequestRegistration(
        gun.user().is.pub
      );
      var accounts = await window.web3.eth.getAccounts();
      msg.send({ from: accounts[0] });
    }
  },
  created() {
    MedicsManager.GetMedicRegistrationContract(
      process.env.VUE_APP_MEDIC_REGISTRATION
    ).then(async contract => {
      this.medicContract = contract;
    });
  }
};
</script>
<style lang="scss" scoped>
#menu {
  background-color: #3cb1bb;
  padding: 1em;
}
.off-canvas {
  .off-canvas-toggle {
    background: #3cb1bb;
    border-color: transparent;
    // font-size: 1.5em;
    // width: 2em;
    // height: 2em;
    i {
      // vertical-align: -webkit-baseline-middle;
    }
  }
}

ul {
  margin: 0;
  list-style: none;
  font-size: 1.5em;
  margin-top: 5em;
  li {
    a,
    a:visited {
      color: #f2f2f2 !important;
    }
  }
}
.register-medic {
  color: white;
  position: absolute;
  bottom: 50px;
  text-align: center;
  cursor: pointer;
}
</style>